let storage = {
  setLs: function (key, val) {
    const localStorage = window.localStorage
    if (typeof key !== 'undefined' && key !== null) {
      try {
        localStorage.setItem(key, JSON.stringify(val))
      } catch (e) {
        return false
      }
    } else {
      return false
    }
  },
  getLs: function (key) {
    const localStorage = window.localStorage
    let valStr

    if (typeof key !== 'undefined' && key !== null) {
      valStr = localStorage.getItem(key)
    } else {
      return false
    }

    if (valStr !== 'undefined' && valStr !== 'null') {
      try {
        return JSON.parse(valStr)
      } catch (e) {
        return false
      }
    } else {
      return false
    }
  },
  delLs: function (v) {
    return localStorage.removeItem(v)
  },
  delAll: function () {
    localStorage.clear()
    sessionStorage.clear()
    return true
  },
  hasLs: function (v) {
    var type = localStorage.getItem(v)
    type = !!type
    return type
  },
  getParams: function (location) {
    const { search } = location
    const params = search.replace(/^\?+/, '').split('&')
    let paramsObj = {}
    params.forEach(item => {
      const param = item.split('=')
      if (param[0] && param[1]) {
        paramsObj[param[0]] = param[1]
      }
    })
    return paramsObj
  }
}
export default storage
